import React from 'react'
import Slider from 'rc-slider'
import injectSheet from 'react-jss'
import style, { handleStyle } from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function handle(props) {
  const { value, offset } = props

  return (
    <div style={{ ...handleStyle, left: `calc(${offset}% - 1rem` }}>{value}°</div>
  )
}

const RangeAngleOfViewDisplay = ({ min, max, callback, id, angleOfView, angleToUpdate, bottomRowToggle, classes, uiAction }) => {
  return (
    <div className={bottomRowToggle ? classes.container : ''}>
      <div title='Horizontal Angle of View' className={classes.rangeLabel}>HAoV <span className={classes.rangeValue}>({min}° - {max}°)</span></div>
      <div className={bottomRowToggle ? classes.sliderContainer : classes.mobileSliderContainer}>
        <Slider
          min={min}
          max={max}
          step={0.1}
          defaultValue={max}
          value={isNaN(angleOfView) ? min : angleOfView}
          marks={{ [min]: {}, [max]: {} }}
          handle={handle}
          onChange={aov => callback(`${aov}`, `${angleToUpdate}AngleOfView`, id)}
        />
      </div>
      { bottomRowToggle &&
        <a
          onClick={uiAction}
          className={classes.bottomRowButton}
          title = 'Show Imager Size and Focal Length'
        >
          <FontAwesomeIcon icon='cog' />
        </a>
      }
    </div>
  )
}

export default injectSheet(style)(RangeAngleOfViewDisplay)



// WEBPACK FOOTER //
// ./src/components/AngleOfViewContainer/RangeAngleOfViewDisplay/index.js